import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import { jsx as _jsx } from "react/jsx-runtime";
var BreadcrumbSeparator = function BreadcrumbSeparator(_ref) {
  var children = _ref.children;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("breadcrumb");
  return /*#__PURE__*/_jsx("span", {
    className: "".concat(prefixCls, "-separator"),
    children: children || "/"
  });
};
BreadcrumbSeparator.__PI_BREADCRUMB_SEPARATOR = true;
export default BreadcrumbSeparator;